import { gql } from '@apollo/client';

export default gql`
  mutation validateTickets($validations: [TicketValidationInput!], $validatedBy: String) {
    validateTickets(validations: $validations, validatedBy: $validatedBy)
  }
`;
